/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { InviteUserOptions, InviteUserResponses } from '../../models/InviteUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Invite a user to the org.
 * @summary Invite User
 * {@link /org/invite}
 */
export function inviteUser<ThrowOnError extends boolean = true>(options: Options<InviteUserOptions, ThrowOnError>): Promise<UnwrappedResult<InviteUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/org/invite', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<InviteUserResponses, ThrowOnError>>
}
